import { Component, Vue } from "vue-property-decorator";
import Axios from "../../plugins/http";

@Component
export default class ShopIndex extends Vue {
    list:any = [];
    created() {
        this.getList();
    }
    getList(){
        Axios.getSecret('/admin/shop/bind/list').then((res:any)=>{
            if(res.data.status === 200){
                this.list = res.data.data || [];
            }else{
                this.$message.error(res.data.msg);
            }
        })
        
    }
    onChoose(id:string){
        let data = {
            shopId:id
        }
        Axios.postByJson('/admin/shop/manage',data).then((res:any)=>{
            if(res.data.status === 200){
                window.localStorage.setItem('OPEN_ADMIN_SHOPID',id)
                this.$router.push({ path: "/admin" });
            }else{
                this.$message.error(res.data.msg);
            }
        })
    }
}